import React, { FC, useRef, useState } from 'react';
import Button from '../Button';
import { MenuDropdownArrowIcon, MenuDropdownIcon } from '../../assets/svg';
import { useOutsideClick } from '../../hooks';
import { ILink } from '../../types';
import './styles.scss';

interface IMenuDropdown {
  links: ILink[];
}

const MenuDropdown: FC<IMenuDropdown> = ({ links }) => {
  const [isOpen, setOpen] = useState<boolean>(false);

  const dropdownRef = useRef(null);
  useOutsideClick(dropdownRef, () => setOpen(false));

  return links.length ? (
    <div className='hbh-menu-dropdown' ref={dropdownRef}>
      <Button icon={<MenuDropdownIcon />} variant='icon' onClick={() => setOpen(!isOpen)} />
      {isOpen && (
        <div className='dropdown'>
          {links.map((item) => (
            <a className='link' key={item.label} href={item.link} rel='noreferrer'>
              {item.label}
              <MenuDropdownArrowIcon />
            </a>
          ))}
        </div>
      )}
    </div>
  ) : null;
};

export default MenuDropdown;
